// extracted by mini-css-extract-plugin
module.exports = {"cGatsbyBackground":"s_b","pLoading":"s_bB","pLoading__inner":"s_bC","pLoading__logo":"s_bD","pLoading__text":"s_bF","animationMarquee":"s_d"};